module.exports = __webpack_public_path__ + "static/media/main_img2.e990e66d.svg";